export function fakeRequest(time) {
    return new Promise((res) => setTimeout(res, time));
}
//# sourceMappingURL=fakeRequest.js.map